import React from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';


const FileUpload = ({ message = "Uploading Files", status = 0 }) => {
    const isOpen = status;
  
    return (
      <Modal isOpen={isOpen} centered>        
        <ModalBody>
          <div className="text-center">
            {/* Replace with your loading animation GIF */}
            <img style={{height: "100px" ,marginBottom:"15px"}} src="https://media.tenor.com/On7kvXhzml4AAAAj/loading-gif.gif" alt="Loading..." />
            <p>{message}</p>
          </div>
        </ModalBody>
      </Modal>
    );
  };
  
  export default FileUpload;